import axios from "axios";
import { BASE_URL_AUTOX, getConfig } from "../../request";

export function updateStatePrice(token, data) {
    return axios.post(`${BASE_URL_AUTOX}car/city-price/state-price-bulk-change`, data, getConfig(token));
}

export default { updateStatePrice }